<div
  class="w-full max-w-sm p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:p-6 md:p-8 dark:bg-gray-800 dark:border-gray-700"
>
  <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="space-y-6" action="#">
    <h5 class="text-xl font-medium text-gray-900 dark:text-white">Create Account ✨</h5>
    <div>
      <label for="username" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
        >Username</label
      >
      <input
        type="text"
        name="username"
        formControlName="username"
        id="username"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
        placeholder="Enter username"
        required
        autocomplete="username"
      />
    </div>
    <div>
      <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
        >Password</label
      >
      <input
        type="password"
        formControlName="password"
        name="password"
        id="password"
        placeholder="••••••••"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
        required
        autocomplete="current-password"
      />
    </div>
    <div>
      <label
        for="confirmPassword"
        class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
        >Confirm password</label
      >
      <input
        type="password"
        formControlName="confirmPassword"
        name="confirmPassword"
        id="confirmPassword"
        placeholder="••••••••"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
        required
        autocomplete="current-password"
      />
    </div>
    <div class="flex items-start">
      <div class="flex items-start">
        @if (registerForm.errors?.['passwordMismatch'] && registerForm.touched) {
          <p class="text-red-600 text-xs text-left -mt-2 mb-2">Passwords do not match</p>
        }
      </div>
    </div>

    <button
      type="submit"
      [disabled]="registerForm.invalid"
      class="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    >
      Create Account
    </button>
    <div class="text-sm font-medium text-gray-500 dark:text-gray-300">
      Already have an account?
      <a routerLink="/login" class="text-blue-700 hover:underline dark:text-blue-500">Login</a>
    </div>
  </form>
</div>
